// extracted by mini-css-extract-plugin
export default {"addressAction":"p5-z","loading":"q5-z"};